exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-page[data-v-8cbca1fc]{min-height:100vh;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#409eff,#67c23a)}.login-page__panel[data-v-8cbca1fc]{width:420px;padding:32px;border-radius:12px;background:#fff;box-shadow:0 12px 40px rgba(0,0,0,.15)}.login-page__title[data-v-8cbca1fc]{font-size:24px;font-weight:600;color:#303133}.login-page__subtitle[data-v-8cbca1fc]{margin-top:8px;margin-bottom:24px;color:#909399}.login-page__button[data-v-8cbca1fc]{width:100%}.login-page__alert[data-v-8cbca1fc]{margin-bottom:16px}.login-page__hint[data-v-8cbca1fc]{margin-top:16px;color:#909399;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8cbca1fc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/views/Login.vue
// module id = Fk5p
// module chunks = 0